import { render, staticRenderFns } from "./CommunityGettingStarted.vue?vue&type=template&id=756e8241&"
import script from "./CommunityGettingStarted.vue?vue&type=script&lang=js&"
export * from "./CommunityGettingStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports